import { directive as vClickOutside } from 'vue-clickaway'
import VTooltip from 'v-tooltip'


const GlobalDirectives = {
  install (Vue) {
    Vue.directive('click-outside', vClickOutside)
    Vue.use(VTooltip)
  }
}

export default GlobalDirectives
